import { Configuration } from '@azure/msal-browser';

import { basePath } from '../utils/base-path';

export const msalConfig: Configuration = {
  auth: {
    clientId: '3b3105a6-e61e-4eee-bf49-3411aba066e3',
    authority: 'https://login.microsoftonline.com/organizations',
    // The redirect must come back to the login page (where the login is started), inside the
    // app base path. MSAL then processes the response on that same page (no navigation), so
    // there is no detour through the origin root and no intermediate route is shown.
    // NOTE: this exact URI must be registered as a redirect URI on the Azure app registration.
    redirectUri: `${window.location.origin}${basePath}login`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Required for the redirect flow inside the APK (Custom Tab): keeps the auth
    // state available across the navigation to Microsoft and back.
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};
